<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="活动分类"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            placeholder="请选择活动分类"
            v-decorator="[
              'activityClassify',
              { rules: [{ required: true, message: '请选择活动分类' }] },
            ]"
            :triggerChange="true"
            dictCode="activity_classify"
          />
        </a-form-item>
        <a-form-item
          label="活动名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入活动名称，限制15个字' },
                ],
              },
            ]"
            placeholder="请输入活动名称，限制15个字"
          />
        </a-form-item>
        <a-form-item
          label="负责人"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            @change="createUserChangeHandle"
            v-decorator="[
              'createUserType',
              { rules: [{ required: true, message: '请设置负责人' }] },
            ]"
            placeholder="请设置负责人"
          >
            <a-select-option
              v-for="(item, index) in createUserTypeFlag"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="showCreateUserInput"
          label="指定负责人"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'createUser',
              { rules: [{ required: true, message: '请输入指定负责人' }] },
            ]"
            placeholder="请输入指定负责人"
          />
        </a-form-item>
        <a-form-item
          label="预计目标数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            v-decorator="[
              'targetNum',
              { rules: [{ required: true, message: '请输入预计目标数' }] },
            ]"
            placeholder="请输入预计目标数"
            type="number"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="活动渠道"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-multi-select-tag
            mode="multiple"
            v-decorator="[
              'activityChannel',
              { rules: [{ required: true, message: '请选择活动渠道' }] },
            ]"
            :triggerChange="true"
            placeholder="请选择活动渠道"
            dictCode="activity_channel_type"
          />
        </a-form-item>
        <a-form-item
          label="活动方式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group
            name="radioGroup"
            v-model="checkedBoxValue"
            @change="changeCheckedValue"
          >
            <a-radio :value="1"> 逐一方式 </a-radio>
            <a-radio :value="2"> 组队方式 </a-radio>
            <a-radio :value="3"> 阶梯方式 </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          label="排行榜数据展示"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            @change="typeChangeHandle"
            v-decorator="[
              'inviteRankingType',
              {
                rules: [
                  { required: true, message: '请选择邀请排行榜数据展示类型' },
                ],
              },
            ]"
            :triggerChange="true"
            placeholder="请选择邀请排行榜数据展示类型"
            dictCode="invite_ranking_type"
          />
        </a-form-item>
        <a-form-item
          v-if="showDateFlag"
          label="指定日期区间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-range-picker
            format="YYYY-MM-DD"
            :disabled-date="disabledDate"
            v-decorator="[
              'rankingDate',
              { rules: [{ required: true, message: '请选择排行榜日期区间' }] },
            ]"
            :show-time="{
              hideDisabledOptions: true,
              defaultValue: [moment('00:00:00'), moment('11:59:59')],
            }"
          />
        </a-form-item>

        <div style="margin-left: 340px; margin-bottom: 10px; font-weight: 600">
          参与规则
        </div>

        <a-form-item
          label="单人总邀请上限"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            v-decorator="['personTotalLimit']"
            placeholder="请输入单人总邀请上限"
            type="number"
          ></a-input>
        </a-form-item>
        <a-form-item
          v-if="checkedBoxValue === 1 || checkedBoxValue === 3"
          label="单人单日可邀请人数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            v-decorator="['personDayLimit']"
            placeholder="请输入单人单日可邀请人数上限（不配置代表不限制）"
            type="number"
          ></a-input>
        </a-form-item>
        <a-form-item
          v-if="checkedBoxValue === 1 || checkedBoxValue === 2"
          :label="inviteUnitNumLable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            v-decorator="['inviteUnitNum']"
            :placeholder="singleNumText"
            type="number"
          ></a-input>
        </a-form-item>

        <a-form-item
          label="邀请上限后继续保存"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="saveInviteRecord"
            @change="changeSaveInviteRecord"
          />
        </a-form-item>

        <div
          v-if="checkedBoxValue === 1 || checkedBoxValue === 2"
          style="margin-left: 340px; margin-bottom: 10px; font-weight: 600"
        >
          权益设置
        </div>
        <div
          v-if="checkedBoxValue === 3"
          style="margin-left: 340px; margin-bottom: 10px; font-weight: 600"
        >
          任务设置
        </div>

        <div v-if="checkedBoxValue === 1" style="font-weight: 600">
          邀请人奖品
        </div>
        <div v-if="checkedBoxValue === 2" style="font-weight: 600">
          队长奖品
        </div>

        <a-form-item
          v-if="checkedBoxValue === 1 || checkedBoxValue === 2"
          label="奖品来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['inviterPrizeSource']"
            placeholder="请选择奖品来源"
            @change="prizeSourceHandleInviter"
          >
            <a-select-option
              v-for="(item, index) in prizeSourceList"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="checkedBoxValue === 1 || checkedBoxValue === 2"
          label="奖品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select v-decorator="['inviterPrize']" placeholder="请选择奖品">
            <a-select-option
              v-for="(item, index) in inviterPrizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <!--  阶段奖励    -->
        <a-form-item
          v-if="checkedBoxValue === 1"
          label="阶段奖励"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="开"
            un-checked-children="关"
            v-model="statePrizeFlag"
            @change="changeStatePrizeFlag"
          />
        </a-form-item>

        <a-row
          v-for="(item, index) in arr2"
          :key="arr2 + index"
          v-if="checkedBoxValue === 1 && statePrizeFlag"
          :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }"
        >
          <a-col :span="10">
            <a-form-item
              label="触发条件"
              :labelCol="labelCol2"
              :wrapperCol="wrapperCol2"
            >
              <a-input
                v-model="statePrizeCondition[index]"
                :min="1"
                :step="1"
                onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
                onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
                placeholder="每日邀请人数触发阈值"
                type="number"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="奖品来源"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-model="statePrizeSource[index]"
                placeholder="请选择奖品来源"
              >
                <a-select-option
                  v-for="(item, index) in prizeSourceList"
                  :value="item.value"
                  :key="index"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item
              label="奖品"
              :labelCol="labelCol2"
              :wrapperCol="wrapperCol2"
            >
              <a-select
                @dropdownVisibleChange="getStatePrizes(index)"
                v-model="statePrizeId[index]"
                placeholder="请选择奖品"
              >
                <a-select-option
                  v-for="(item, index) in statePrizesList"
                  :value="item.id"
                  :key="index"
                  >{{ item.prizesName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="数量"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-model="statePrizeNum[index]"
                :min="1"
                :step="1"
                onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
                onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
                placeholder="奖励数量"
                type="number"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="2">
            <a-button
              v-if="statePrizeFlag && arr2.length > 1"
              @click="stateHandleDel(index)"
            >
              <a-icon type="minus" />
            </a-button>
          </a-col>
        </a-row>

        <a-button
          style="width: 300px; margin-left: 230px; margin-bottom: 20px"
          block
          v-if="checkedBoxValue === 1 && statePrizeFlag"
          @click="stateHandleAdd"
        >
          <a-icon type="plus" />
        </a-button>

        <!--阶梯方式，任务设置-->
        <a-row
          v-for="(item, index) in arr1"
          :key="index"
          v-if="checkedBoxValue === 3"
          :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }"
        >
          <a-col :span="10">
            <a-form-item
              label="任务"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select v-model="taskId[index]" placeholder="请选择任务">
                <a-select-option
                  v-for="(item, index) in taskList"
                  :value="item.id"
                  :key="index"
                  >{{ item.activityName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="奖品来源"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                v-model="prizeSource[index]"
                placeholder="请选择奖品来源"
                @change="prizeSourceHandle"
              >
                <a-select-option
                  v-for="(item, index) in prizeSourceList"
                  :value="item.value"
                  :key="index"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item
              label="奖品"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-select
                @dropdownVisibleChange="getPrizes(index)"
                v-model="prizeId[index]"
                placeholder="请选择奖品"
              >
                <a-select-option
                  v-for="(item, index) in prizesList"
                  :value="item.id"
                  :key="index"
                  >{{ item.prizesName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="权益数量"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-model="prizeNum[index]"
                :min="0"
                :step="1"
                onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
                onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
                placeholder="请输入权益数量"
                type="number"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="2">
            <a-button
              v-if="checkedBoxValue === 3 && arr1.length > 1"
              @click="handleDel(index)"
            >
              <a-icon type="minus" />
            </a-button>
          </a-col>
        </a-row>

        <a-button
          style="width: 300px; margin-left: 230px; margin-bottom: 20px"
          block
          v-if="checkedBoxValue === 3"
          @click="handleAdd"
        >
          <a-icon type="plus" />
        </a-button>

        <div style="font-weight: 600">被邀请人奖品</div>
        <a-form-item
          label="奖品来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['invitedPrizeSource']"
            placeholder="请选择奖品来源"
            @change="prizeSourceHandleInvited"
          >
            <a-select-option
              v-for="(item, index) in prizeSourceList"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="奖品" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="['invitedPrize']" placeholder="请选择奖品">
            <a-select-option
              v-for="(item, index) in invitedPrizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="活动时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-range-picker
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            v-decorator="['startEndTime']"
            :show-time="{
              hideDisabledOptions: true,
              defaultValue: [
                moment('00:00:00', 'HH:mm:ss'),
                moment('11:59:59', 'HH:mm:ss'),
              ],
            }"
          />
        </a-form-item>
        <a-form-item
          label="活动内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            type="text"
            :max-length="200"
            rows="3"
            v-decorator="['activityContent']"
            placeholder="请输入活动内容,限制200字"
          />
        </a-form-item>
        <a-form-item
          label="活动达标描述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            type="text"
            :max-length="200"
            rows="3"
            v-decorator="['activityDescribe']"
            placeholder="请输入活动达标描述,限制200字"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';

export default {
  name: 'MgmModal',
  components: {
    JDate,
    JMultiSelectTag,
  },
  data() {
    return {
      arr1: [1],
      taskId: [], //任务集合
      prizeSource: [], //奖品来源集合
      prizeId: [], //奖品集合
      prizeNum: [], //权益数量集合
      showCreateUserInput: false,
      showDateFlag: false,
      arr2: [1],
      statePrizeCondition: [], //阶段条件集合
      statePrizeSource: [], //阶段奖品来源集合
      statePrizeId: [], //阶段奖品集合
      statePrizeNum: [], //阶段奖励数量集合

      statePrizeFlag: false,
      saveInviteRecord: false,

      createUserTypeFlag: [
        //负责人类型
        {
          name: '当前登录账号',
          value: '1',
        },
        {
          name: '指定负责人',
          value: '2',
        },
      ],

      checkedBoxValue: 1, //默认1
      showPersonDayLimit: true,
      showInviteUnitNum: true,
      inviteUnitNumLable: '邀请单位数',
      singleNumText: '请输入邀请单位数（每邀请xx人获得一次权益）',

      statePrizesList: [],
      prizesList: [],
      indexTemp: -1,

      inviterPrizesList: [], //邀请人奖品列表
      invitedPrizesList: [], //被邀请人奖品列表
      taskList: [], //任务列表
      prizeSourceList: [
        {
          name: '奖品库',
          value: '1',
        },
        {
          name: '积分库',
          value: '2',
        },
      ], //奖品来源

      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      labelCol2: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/mgm/activity/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/mgm/activity/edit',
        getPrizeList:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/getPrizeList',
        getTaskList:
          process.env.VUE_APP_CMS_MARKETING + '/run/activity/getTaskList',
        getIntegralList:
          process.env.VUE_APP_CMS_MARKETING +
          '/integral/manage/getIntegralList',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'saveInviteRecord',
            'statePrizeCondition',
            'statePrizeSource',
            'statePrizeId',
            'statePrizeNum',
            'statePrizeFlag',
            'createUserType',
            'activityChannel',
            'rankingDate',
            'inviteRankingType',
            'activityClassify',
            'createUser',
            'name',
            'targetNum',
            'activityType',
            'personTotalLimit',
            'personDayLimit',
            'inviteUnitNum',
            'inviterPrize',
            'inviterPrizeSource',
            'invitedPrizeSource',
            'invitedPrize',
            'startEndTime',
            'activityContent',
            'activityDescribe',
            'taskId',
            'prizeSource',
            'prizeId',
            'prizeNum'
          )
        );
      });

      if (this.model.startEndTime) {
        var ary = this.model.startEndTime.split('~');
        this.model.startEndTime = [
          moment(ary[0], 'YYYY-MM-DD HH:mm:ss'),
          moment(ary[1], 'YYYY-MM-DD HH:mm:ss'),
        ];
      }

      if (this.model.inviteRankingType === '3') {
        this.showDateFlag = true;
      } else {
        this.showDateFlag = false;
      }

      if (this.model.rankingDate) {
        var ary = this.model.rankingDate.split('~');
        this.model.rankingDate = [
          moment(ary[0], 'YYYY-MM-DD'),
          moment(ary[1], 'YYYY-MM-DD'),
        ];
      }

      if (this.model.id) {
        this.createUserChangeHandle(this.model.createUserType);
        this.changeCheckedValue2(this.model.activityType);
        this.prizeSourceHandleInviter(this.model.inviterPrizeSource);
        this.prizeSourceHandleInvited(this.model.invitedPrizeSource);
        this.changeStatePrizeFlag(this.model.statePrizeFlag);
        this.changeSaveInviteRecord(this.model.saveInviteRecord);

        if (this.model.activityType === '1') {
          this.checkedBoxValue = 1;
        } else if (this.model.activityType === '2') {
          this.checkedBoxValue = 2;
        } else {
          this.checkedBoxValue = 3;
        }

        this.arr1 = [];
        this.taskId = [];
        this.prizeSource = [];
        this.prizeId = [];
        this.prizeNum = [];

        this.arr2 = [];
        this.statePrizeCondition = [];
        this.statePrizeSource = [];
        this.statePrizeId = [];
        this.statePrizeNum = [];

        if (this.model.taskId) {
          if (this.model.taskId.indexOf(',') !== -1) {
            let newArr = this.model.taskId.split(',');
            newArr.forEach((item) => {
              this.arr1.push(item);
              this.taskId.push(item);
            });
          } else {
            this.taskId.push(this.model.taskId);
            this.arr1 = [1];
          }
        } else {
          this.arr1 = [1];
        }
        if (this.model.statePrizeCondition) {
          if (this.model.statePrizeCondition.indexOf(',') !== -1) {
            let newArr = this.model.statePrizeCondition.split(',');
            newArr.forEach((item) => {
              this.arr2.push(item);
              this.statePrizeCondition.push(item);
            });
          } else {
            this.statePrizeCondition.push(this.model.statePrizeCondition);
            this.arr2 = [1];
          }
        } else {
          this.arr2 = [1];
        }
        if (this.model.prizeSource) {
          if (this.model.prizeSource.indexOf(',') !== -1) {
            let newArr = this.model.prizeSource.split(',');
            newArr.forEach((item) => {
              this.prizeSource.push(item);
            });
          } else {
            this.prizeSource.push(this.model.prizeSource);
          }
        }
        if (this.model.statePrizeSource) {
          if (this.model.statePrizeSource.indexOf(',') !== -1) {
            let newArr = this.model.statePrizeSource.split(',');
            newArr.forEach((item) => {
              this.statePrizeSource.push(item);
            });
          } else {
            this.statePrizeSource.push(this.model.statePrizeSource);
          }
        }
        if (this.model.prizeId) {
          if (this.model.prizeId.indexOf(',') !== -1) {
            let newArr = this.model.prizeId.split(',');
            newArr.forEach((item) => {
              this.prizeId.push(item);
            });
          } else {
            this.prizeId.push(this.model.prizeId);
          }
        }
        if (this.model.statePrizeId) {
          if (this.model.statePrizeId.indexOf(',') !== -1) {
            let newArr = this.model.statePrizeId.split(',');
            newArr.forEach((item) => {
              this.statePrizeId.push(item);
            });
          } else {
            this.statePrizeId.push(this.model.statePrizeId);
          }
        }
        if (this.model.prizeNum) {
          if (this.model.prizeNum.indexOf(',') !== -1) {
            let newArr = this.model.prizeNum.split(',');
            newArr.forEach((item) => {
              this.prizeNum.push(item);
            });
          } else {
            this.prizeNum.push(this.model.prizeNum);
          }
        }
        if (this.model.statePrizeNum) {
          if (this.model.statePrizeNum.indexOf(',') !== -1) {
            let newArr = this.model.statePrizeNum.split(',');
            newArr.forEach((item) => {
              this.statePrizeNum.push(item);
            });
          } else {
            this.statePrizeNum.push(this.model.statePrizeNum);
          }
        }
      } else {
        this.checkedBoxValue = 1;
        this.arr1 = [1];
        this.taskId = [];
        this.prizeSource = [];
        this.prizeId = [];
        this.prizeNum = [];
        this.prizesList = [];
        this.arr2 = [1];
        this.statePrizeCondition = [];
        this.statePrizeSource = [];
        this.statePrizeId = [];
        this.statePrizeNum = [];
        this.statePrizesList = [];
        this.statePrizeFlag = false;
        this.saveInviteRecord = false;
        this.changeCheckedValue2('0');
      }
      this.prizeSourceHandle('1');
      this.prizeSourceHandle('2');
      this.getTaskList();
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }

          let formData = Object.assign(this.model, values);
          if (formData.startEndTime && formData.startEndTime.length !== 0) {
            formData.startEndTime =
              formData.startEndTime[0].format('YYYY-MM-DD HH:mm:ss') +
              '~' +
              formData.startEndTime[1].format('YYYY-MM-DD HH:mm:ss');
          } else {
            formData.startEndTime = '';
          }

          if (formData.rankingDate && formData.rankingDate.length !== 0) {
            formData.rankingDate =
              formData.rankingDate[0].format('YYYY-MM-DD') +
              '~' +
              formData.rankingDate[1].format('YYYY-MM-DD');
          } else {
            formData.rankingDate = '';
          }

          formData.activityType = this.checkedBoxValue;
          formData.taskId = JSON.stringify(that.taskId);
          formData.prizeSource = JSON.stringify(that.prizeSource);
          formData.prizeId = JSON.stringify(that.prizeId);
          formData.prizeNum = JSON.stringify(that.prizeNum);

          formData.statePrizeCondition = JSON.stringify(
            that.statePrizeCondition
          );
          formData.statePrizeSource = JSON.stringify(that.statePrizeSource);
          formData.statePrizeId = JSON.stringify(that.statePrizeId);
          formData.statePrizeNum = JSON.stringify(that.statePrizeNum);
          formData.statePrizeFlag = that.statePrizeFlag === true ? '1' : '0';
          formData.saveInviteRecord =
            that.saveInviteRecord === true ? '1' : '0';

          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'saveInviteRecord',
          'statePrizeCondition',
          'statePrizeSource',
          'statePrizeId',
          'statePrizeNum',
          'statePrizeFlag',
          'createUserType',
          'activityChannel',
          'rankingDate',
          'inviteRankingType',
          'activityClassify',
          'createUser',
          'name',
          'targetNum',
          'activityType',
          'personTotalLimit',
          'personDayLimit',
          'inviteUnitNum',
          'inviterPrize',
          'inviterPrizeSource',
          'invitedPrizeSource',
          'invitedPrize',
          'startEndTime',
          'activityContent',
          'activityDescribe',
          'taskId',
          'prizeSource',
          'prizeId',
          'prizeNum'
        )
      );
    },

    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },

    disabledDate(current) {
      return current && current < moment().subtract(1, 'days'); //当天之前的不可选，不包括当天
    },

    disabledRangeTime(_, type) {
      if (type === 'start') {
        return {
          disabledHours: () => this.range(0, 60).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56],
        };
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56],
      };
    },

    /**获取邀请人奖品列表*/
    getInviterPrizesList(type) {
      let getUrl = '';
      if (type === '1') {
        getUrl = this.url.getPrizeList;
      } else if (type === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.inviterPrizesList = res.result;
          if (type === '2') {
            this.inviterPrizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
        }
      });
    },
    prizeSourceHandleInviter(e) {
      this.inviterPrizesList = [];
      if (e === '1' || e === '2') {
        this.getInviterPrizesList(e);
      }
    },

    /**获取被邀请人奖品列表*/
    getInvitedPrizesList(type) {
      let getUrl = '';
      if (type === '1') {
        getUrl = this.url.getPrizeList;
      } else if (type === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.invitedPrizesList = res.result;
          if (type === '2') {
            this.invitedPrizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
        }
      });
    },
    prizeSourceHandleInvited(e) {
      this.invitedPrizesList = [];
      if (e === '1' || e === '2') {
        this.getInvitedPrizesList(e);
      }
    },

    /**获取被邀请人奖品列表*/
    getPrizesList(type) {
      let getUrl = '';
      if (type === '1') {
        getUrl = this.url.getPrizeList;
      } else if (type === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          this.statePrizesList = res.result;
          if (type === '2') {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
            this.statePrizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
        }
      });
    },
    prizeSourceHandle(e) {
      this.prizesList = [];
      this.statePrizesList = [];
      if (e === '1' || e === '2') {
        this.getPrizesList(e);
      }
    },

    changeCheckedValue(e) {
      this.prizeSourceHandle('1');
      this.prizeSourceHandle('2');
      let tmpValue = e.target.value;
      this.checkedBoxValue = tmpValue;
      if (tmpValue === 1) {
        this.showPersonDayLimit = true;
        this.showInviteUnitNum = true;
        this.inviteUnitNumLable = '邀请单位数';
        this.singleNumText = '请输入邀请单位数（每邀请xx人获得一次权益）';
      } else if (tmpValue === 2) {
        this.showPersonDayLimit = false;
        this.showInviteUnitNum = true;
        this.inviteUnitNumLable = '队伍人数';
        this.singleNumText = '请输入队伍人数';
      } else if (tmpValue === 3) {
        this.showPersonDayLimit = true;
        this.showInviteUnitNum = false;
        this.inviteUnitNumLable = '邀请单位数';
        this.singleNumText = '请输入邀请单位数（每邀请xx人获得一次权益）';
      } else {
        this.showPersonDayLimit = true;
        this.showInviteUnitNum = true;
        this.inviteUnitNumLable = '邀请单位数';
        this.singleNumText = '请输入邀请单位数（每邀请xx人获得一次权益）';
      }
    },

    changeCheckedValue2(e) {
      if (e === '1') {
        this.showPersonDayLimit = true;
        this.showInviteUnitNum = true;
        this.inviteUnitNumLable = '邀请单位数';
        this.singleNumText = '请输入邀请单位数（每邀请xx人获得一次权益）';
      } else if (e === '2') {
        this.showPersonDayLimit = false;
        this.showInviteUnitNum = true;
        this.inviteUnitNumLable = '队伍人数';
        this.singleNumText = '请输入队伍人数';
      } else if (e === '3') {
        this.showPersonDayLimit = true;
        this.showInviteUnitNum = false;
        this.inviteUnitNumLable = '邀请单位数';
        this.singleNumText = '请输入邀请单位数（每邀请xx人获得一次权益）';
      } else {
        this.showPersonDayLimit = true;
        this.showInviteUnitNum = true;
        this.inviteUnitNumLable = '邀请单位数';
        this.singleNumText = '请输入邀请单位数（每邀请xx人获得一次权益）';
      }
    },

    handleAdd() {
      let newArr = [1];
      this.arr1 = this.arr1.concat(newArr);
      console.log(this.arr1);
    },

    handleDel(index) {
      console.log(index);
      this.arr1.splice(index, 1);
      this.taskId.splice(index, 1);
      this.prizeSource.splice(index, 1);
      this.prizeId.splice(index, 1);
      this.prizeNum.splice(index, 1);
    },

    stateHandleAdd() {
      let newArr = [1];
      this.arr2 = this.arr2.concat(newArr);
    },

    stateHandleDel(index) {
      console.log(index);
      this.arr2.splice(index, 1);
      this.statePrizeCondition.splice(index, 1);
      this.statePrizeSource.splice(index, 1);
      this.statePrizeId.splice(index, 1);
      this.statePrizeNum.splice(index, 1);
    },

    /**获取任务列表*/
    getTaskList() {
      getAction(this.url.getTaskList).then((res) => {
        if (res.success) {
          this.taskList = res.result;
        }
      });
    },
    /**根据奖品来源获取奖品列表*/
    getPrizes(index) {
      this.prizesList = [];
      let getUrl = '';
      if (this.prizeSource[index] === '1') {
        getUrl = this.url.getPrizeList;
      } else if (this.prizeSource[index] === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          if (this.prizeSource[index] === '2') {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
          console.log(this.prizesList);
        }
      });
    },

    /**根据奖品来源获取奖品列表*/
    getStatePrizes(index) {
      this.statePrizesList = [];
      let getUrl = '';
      if (this.statePrizeSource[index] === '1') {
        getUrl = this.url.getPrizeList;
      } else if (this.statePrizeSource[index] === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.statePrizesList = res.result;
          if (this.statePrizeSource[index] === '2') {
            this.statePrizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
          console.log(this.statePrizesList);
        }
      });
    },

    typeChangeHandle(e) {
      if (e === '3') {
        this.showDateFlag = true;
      } else {
        this.showDateFlag = false;
      }
    },

    createUserChangeHandle(e) {
      if (e === '2') {
        this.showCreateUserInput = true;
      } else {
        this.showCreateUserInput = false;
      }
    },

    changeStatePrizeFlag(e) {
      if (e === '1') {
        e = true;
      } else if (e === '0') {
        e = false;
      }
      this.statePrizeFlag = e;
    },

    changeSaveInviteRecord(e) {
      if (e === '1') {
        e = true;
      } else if (e === '0') {
        e = false;
      }
      this.saveInviteRecord = e;
    },
  },
};
</script>
<style scoped>
.steps-content {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  /*text-align: center;*/
  padding-top: 80px;
}

.steps-action {
  margin-top: 24px;
}
</style>
